import React from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { Image } from '@fiverr-private/media';
import { AspectRatioContainer } from '../AspectRatioContainer';
import videoPlayIcon from '../assets/play_icon.svg';

export function VideoThumbnail({ src, ...rest }) {
    return (
        <AspectRatioContainer {...rest} cursor="pointer">
            <Image
                src={src}
                alt={translate('reviews.gigs.work_sample.small')}
                objectFit="cover"
                width="100%"
                height="100%"
                borderRadius="sm"
            />
            <Image
                alt=""
                src={videoPlayIcon}
                role="presentation"
                position="absolute"
                width="24px"
                height="24px"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
            />
        </AspectRatioContainer>
    );
}
